import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_sidebar/investor')({
  component: InvestorLayout,
})

function InvestorLayout() {
  return <Outlet />
}

